import React, { type FC } from 'react';

import { getTranslation } from '@confluence/i18n/entry-points/translation.ts';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { type FullPageEditorPresetAPI } from '@confluence/full-page-editor-store';

import { READ_TIME_METRIC } from './perf.config.ts';
import { EditorReadTime } from './EditorReadTime.tsx';
import { OriginalReadTime } from './OriginalReadTime.tsx';

type ReadTimeProps = {
	contentId: string;
	editorApi?: FullPageEditorPresetAPI | null;
	isInEditor?: boolean;
	isAbbreviatedReadTime?: boolean;
	isDetailsPanel?: boolean;
	showWordCount?: boolean;
};

export const ReadTimeLoader: FC<ReadTimeProps> = ({
	contentId,
	editorApi,
	isInEditor,
	isAbbreviatedReadTime,
	isDetailsPanel,
	showWordCount,
}) => {
	return (
		<>
			<PageSegmentLoadStart metric={READ_TIME_METRIC} />
			<ReadTime
				contentId={contentId}
				editorApi={editorApi}
				isInEditor={isInEditor}
				isAbbreviatedReadTime={isAbbreviatedReadTime}
				isDetailsPanel={isDetailsPanel}
				showWordCount={showWordCount}
			/>
		</>
	);
};

export const ReadTime: FC<ReadTimeProps> = ({
	contentId,
	editorApi,
	isInEditor,
	isAbbreviatedReadTime,
	isDetailsPanel,
	showWordCount,
}) => {
	const { locale } = getTranslation();
	const shouldRenderReadTime = locale && locale.substring(0, 2).toLowerCase() === 'en';

	if (!shouldRenderReadTime) {
		return null;
	}

	return isInEditor ? (
		<EditorReadTime
			contentId={contentId}
			editorApi={editorApi}
			showWordCount={showWordCount}
			isDetailsPanel={isDetailsPanel}
			isAbbreviatedReadTime={isAbbreviatedReadTime}
		/>
	) : (
		<OriginalReadTime
			contentId={contentId}
			isAbbreviatedReadTime={isAbbreviatedReadTime}
			isDetailsPanel={isDetailsPanel}
			showWordCount={showWordCount}
		/>
	);
};
